// extracted by mini-css-extract-plugin
export default {"link":"PersonLinkBack_link__Hozwf","link__img":"PersonLinkBack_link__img__Ck-Mj"};